import SidebarComponent from "../../../components/Sidebar";
import NavbarComponent from "../../../components/Navbar";
import React, { Component } from "react";
import Pagination from "react-js-pagination";
import { tokens, role, format_date, GET, status_refund, baht, total, report_refund_byid } from "../../../components/CustomComponent.js";
import "../../../assets/css/bootstrap.css";
export default class ReFundScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,

      loading: false,
      modal_add: false,
      modal_edit: false,
      modal_delete: false,

      data: null,

      member_name: "",
      invoice_number: "",

      search: "",
    };
  }
  async componentDidMount() {
    await this.GetAll();
  }
  GetAll = async () => {
    this.setState({ loading: true });
    let result = await GET(tokens, "v1/refund/filter-search/page/" + this.state.page + "?data_search=" + this.state.search, null);
    if (result && result.status) {
      this.setState({ data: result.data });
    }
    this.setState({ loading: false });
  };

  Get_by_id = async (id) => {
    let result = await GET(tokens, "v1/refund/rc-number-detail?rc_number=" + id, null);
    if (result && result.status) {
      report_refund_byid(result.data.data);
      this.setState({ loading: false });
    }
  };

  HandlePageChange(pageNumber) {
    this.setState({ page: pageNumber });
    setTimeout(() => {
      this.GetAll();
    }, 10);
  }

  ClearForm() {
    this.setState({
      page: 1,

      id: "",
    });
  }
  render() {
    return (
      <div className="full bg-contain w-100">
        {this.state.loading && (
          <div className="spinner-container">
            <div className="loading-spinner"></div>
          </div>
        )}
        <div className="menu-container">
          <SidebarComponent />
          <div className="bodyw-100">
            <NavbarComponent page1="หน้าหลัก" page2="คืนสินค้า" />
            <div style={{ height: 60 }}></div>
            <div className="w-100 row mx-0 d-flex align-items-center justify-content-between px-3 mt-3">
              <h3>
                <b>คืนสินค้า</b>
              </h3>

              {role.type_commission[1] === 1 && (
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn btn-primary w-100 px-4"
                    onClick={() => {
                      window.location.href = "/refund/create";
                    }}
                  >
                    {" "}
                    เพิ่มรายการ{" "}
                  </button>
                </div>
              )}
            </div>
            <div className="w-100 p-3">
              <div className="card">
                <div className="card-header row d-flex mx-0 px-2 rounded-top-16">
                  <div className="col-6 col-sm-6 col-xl-3 d-flex">
                    <div className="w-100">
                      <input
                        type="search"
                        className="form-control-search"
                        placeholder="พิมพ์คำค้นหา"
                        onChange={(e) => {
                          this.setState({ page: 1, search: e.target.value, loading: false });
                          if (e.target.value === "") {
                            this.setState({ search: "" });
                            setTimeout(() => {
                              this.GetAll();
                              this.setState({ loading: false });
                            }, 20);
                          } else {
                            setTimeout(() => {
                              this.GetAll();
                              this.setState({ loading: false });
                            }, 20);
                          }
                        }}
                        value={this.state.search}
                      ></input>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0 ">
                  <div className="table-responsive rounded-16">
                    <table className="table table-striped table-borderless table-sm table-hover">
                      <thead>
                        <tr>
                          <th className="text-left">
                            <b>เลขที่เอกสาร</b>
                          </th>
                          <th className="text-left">
                            <b>วันที่</b>
                          </th>
                          <th className="text-left">
                            <b>ชื่อลูกค้า</b>
                          </th>
                          <th className="text-center">
                            <b>จำนวนหลา</b>
                          </th>
                          <th className="text-center">
                            <b>จำนวนไม้</b>
                          </th>
                          <th className="text-left">
                            <b>หมายเหตุ</b>
                          </th>
                          <th className="text-center">
                            <b>สถานะ</b>
                          </th>
                          <th className="text-center">
                            <b>จัดการ</b>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {((this.state.data && this.state.data.count === 0) || !this.state.data) && (
                          <tr>
                            <td colSpan={8} className="text-center table-light">
                              -- ไม่มีข้อมูล --
                            </td>
                          </tr>
                        )}
                        {this.state.data &&
                          this.state.data.data.map((item, index) => (
                            <tr key={index} className="pointer">
                              <td className="text-left">{item.rc_number}</td>
                              <td className="text-left">{format_date(item.pick_up_datetime)}</td>
                              <td className="text-left">{item.member_name}</td>
                              <td className="text-center">{item.yard_total ? baht(item.yard_total) : "0.00"}</td>
                              <td className="text-center">{item.wood_total ? item.wood_total : 0}</td>
                              <td className="text-left">{item.remark}</td>
                              <td className="text-center">{status_refund(item.status_refund)}</td>
                              <td className="text-center">
                                <button
                                  className="btn btn-link text-secondary"
                                  onClick={() => {
                                    if (item.status_refund === 1) {
                                      window.location.href = "/refund/update?id=" + item.rc_number + "&member_id=" + item.member_id + "&member_name=" + item.member_name;
                                    } else {
                                      window.location.href = "/refund/details?id=" + item.rc_number + "&member_id=" + item.member_id + "&member_name=" + item.member_name;
                                    }
                                  }}
                                >
                                  <label className="icon mr-2 pointer">{item.status_refund === 1 ? "\uf040" : "\uf570"}</label>
                                </button>
                                <button
                                  className="btn btn-link text-secondary"
                                  onClick={() => {
                                    this.Get_by_id(item.rc_number);
                                  }}
                                >
                                  <label className="icon mr-2 pointer">{"\uf02f"}</label>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td className="text-left">
                            <b>รวม</b>
                          </td>
                          <td className="text-left"></td>
                          <td className="text-left"></td>
                          <td className="text-center">
                            <b>{this.state.data && this.state.data.data && baht(total(this.state.data.data, "yard_total"))} หลา</b>
                          </td>
                          <td className="text-center">
                            <b>{this.state.data && this.state.data.data && total(this.state.data.data, "wood_total")} ไม้</b>
                          </td>
                          <td className="text-left"></td>
                          <td className="text-left"></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              {/* pagination */}
              {this.state.data && this.state.data.data.length !== 0 && (
                <div className="row w-100 justify-content-between mx-0  my-4">
                  <div className="col-12 col-sm-6 col-md-6 col-xl-6 d-flex">
                    <div className="d-flex w-100 justify-content-xl-start justify-content-md-start justify-content-sm-start">
                      <label>
                        {" "}
                        แสดง {this.state.data.end_index} รายการจาก {this.state.data.count} รายการ{" "}
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-6 d-flex ">
                    <div className="d-flex w-100 justify-content-xl-end justify-content-md-end justify-content-sm-end">
                      <button
                        className="btn-circle-white mx-1 pointer"
                        onClick={() => {
                          this.HandlePageChange(1);
                        }}
                      >
                        {" "}
                        <label className="icon pointer">{"\uf100"}</label>{" "}
                      </button>
                      <Pagination activePage={this.state.page} itemsCountPerPage={10} totalItemsCount={this.state.data.count} pageRangeDisplayed={5} onChange={this.HandlePageChange.bind(this)} prevPageText={<label className="icon pointer">{"\uf104"}</label>} nextPageText={<label className="icon pointer">{"\uf105"}</label>} hideFirstLastPages={true} />
                      <button
                        className="btn-circle-white mx-1 pointer"
                        onClick={() => {
                          this.HandlePageChange(this.state.data.page_number);
                        }}
                      >
                        <label className="icon pointer">{"\uf101"}</label>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
